import _extends from 'babel-runtime/helpers/extends';

/* eslint-disable react/no-unused-prop-types */

import React from 'react';
import { gridSize, math } from '@atlaskit/theme';
import { getLoadingStyle } from './utils';

var getMargin = function getMargin(props) {
  if (props.spacing === 'none') return 0;
  // $FlowFixMe TEMPORARY
  if (props.isOnlyChild) return '0 -' + math.divide(gridSize, 4)(props) + 'px';
  // $FlowFixMe TEMPORARY
  return '0 ' + math.divide(gridSize, 2)(props) + 'px';
};

var IconWrapper = function IconWrapper(props) {
  var style = _extends({
    alignSelf: 'center',
    display: 'flex',
    flexShrink: 0,
    lineHeight: 0,
    fontSize: 0,
    margin: getMargin(props),
    userSelect: 'none'
  }, getLoadingStyle(props));
  return React.createElement(
    'span',
    { style: style },
    props.children
  );
};

export default IconWrapper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/button/dist/esm/styled/IconWrapper.js
// module id = 389
// module chunks = 0